import { render, staticRenderFns } from "./eventsControl.vue?vue&type=template&id=2f25be7e&scoped=true&"
import script from "./eventsControl.vue?vue&type=script&lang=js&"
export * from "./eventsControl.vue?vue&type=script&lang=js&"
import style0 from "./eventsControl.vue?vue&type=style&index=0&id=2f25be7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25be7e",
  null
  
)

export default component.exports